'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _VstDropdown = require('./VstDropdown');

var _VstDropdown2 = _interopRequireDefault(_VstDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var upArrow = function upArrow(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '10',
      height: '7',
      viewBox: '0 0 10 7'
    }, props),
    _react2.default.createElement('path', {
      fill: '#40404C',
      d: 'M5 3L1.5 6.5 0 5l5-5 5 5-1.5 1.5z'
    })
  );
};

var downArrow = function downArrow(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '10',
      height: '7',
      viewBox: '0 0 10 7'
    }, props),
    _react2.default.createElement('path', {
      fill: '#40404C',
      d: 'M5 4L1.5.5 0 2l5 5 5-5L8.5.5z'
    })
  );
};

var checkmark = function checkmark(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '16.8',
      height: '14',
      viewBox: '0 0 16.8 14'
    }, props),
    _react2.default.createElement('path', {
      fill: '#40404C',
      d: 'M16.8 2.1L14.7 0 4.9 9.7 2.1 6.9 0 9.1 4.9 14l2.2-2.1z'
    })
  );
};

var path = 'https://bookshelf.vitalsource.com/img/locales/';
var languages = [{ short: 'en', long: 'English', img: 'en.png' }, { short: 'ar', long: 'العربية', img: 'ar.png' }, { short: 'bg', long: 'Български', img: 'bg.png' }, { short: 'ca', long: 'Català', img: 'ca.png' }, { short: 'cs', long: 'čeština', img: 'cs.png' }, { short: 'cy', long: 'Cymraeg', img: 'cy.png' }, { short: 'da', long: 'Dansk', img: 'da.png' }, { short: 'de', long: 'Deutsch', img: 'de.png' }, { short: 'el', long: 'ελληνικά', img: 'el.png' }, { short: 'en_GB', long: 'English (UK)', img: 'en-GB.png' }, { short: 'es', long: 'Español', img: 'es.png' }, { short: 'es_MX', long: 'Español - México', img: 'es-MX.png' }, { short: 'fi', long: 'Suomi', img: 'fi.png' }, { short: 'fil', long: 'Tagalog', img: 'fil.png' }, { short: 'fr_CA', long: 'Français - Canada', img: 'fr-CA.png' }, { short: 'fr', long: 'Français', img: 'fr.png' }, { short: 'gd', long: 'Gaeilge', img: 'gd.png' }, { short: 'he', long: 'עברית', img: 'he.png' }, { short: 'hi', long: 'हिंदी', img: 'hi.png' }, { short: 'is', long: 'Íslenska', img: 'is.png' }, { short: 'it', long: 'Italiano', img: 'it.png' }, { short: 'ja', long: '日本語', img: 'ja.png' }, { short: 'ko', long: '한국어', img: 'ko.png' }, { short: 'nl', long: 'Nederlands', img: 'nl.png' }, { short: 'no', long: 'Norsk', img: 'no.png' }, { short: 'pl', long: 'Polski', img: 'pl.png' }, { short: 'pt_BR', long: 'Português do Brasil', img: 'pt-BR.png' }, { short: 'pt', long: 'Português', img: 'pt.png' }, { short: 'ro', long: 'Română', img: 'ro.png' }, { short: 'ru', long: 'Pусский', img: 'ru.png' }, { short: 'sv', long: 'Svensk', img: 'sv.png' }, { short: 'th', long: 'ภาษาไทย', img: 'th.png' }, { short: 'tr', long: 'Türk', img: 'tr.png' }, { short: 'vi', long: 'Tiếng Việt', img: 'vi.png' }, { short: 'zh_CN', long: '中文简体', img: 'zh-CN.png' }, { short: 'zh_TW', long: '繁體中文', img: 'zh-TW.png' }];

var VstLocales = function (_React$Component) {
  _inherits(VstLocales, _React$Component);

  function VstLocales(props) {
    _classCallCheck(this, VstLocales);

    var _this = _possibleConstructorReturn(this, (VstLocales.__proto__ || Object.getPrototypeOf(VstLocales)).call(this, props));

    _this.state = {
      selected: _this.props.selected
    };
    return _this;
  }

  _createClass(VstLocales, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _VstDropdown2.default,
        {
          className: 'vst-locales ' + this.props.menuName,
          horizontal: this.props.horizontal,
          vertical: this.props.vertical,
          target: this.renderTarget(),
          height: this.props.height,
          customX: this.props.customX,
          customY: this.props.customY,
          isMobile: this.props.isMobile,
          headerTitle: this.props.headerTitle,
          showBackBtn: this.props.showBackBtn,
          showApplyBtn: this.props.showApplyBtn,
          headerBackButton: this.props.headerBackButton,
          scrollable: true
        },
        this.renderLanguages()
      );
    }
  }, {
    key: 'onClick',
    value: function onClick(selected) {
      this.setState({ selected: selected });
      if (this.props.onChange) {
        this.props.onChange(selected);
      }
    }
  }, {
    key: 'renderTarget',
    value: function renderTarget() {
      var _this2 = this;

      var language = languages.find(function (l) {
        return l.short === _this2.state.selected;
      });
      return _react2.default.createElement(
        'button',
        { key: 'vst-locale-target', className: 'vst-locales-button' },
        _react2.default.createElement(
          'span',
          { className: 'vst-locales-target-label' },
          this.props.label
        ),
        _react2.default.createElement(
          'span',
          { className: 'vst-language' },
          this.props.customText || language.long
        ),
        _react2.default.createElement('img', { role: 'presentation', src: path + '/' + language.img }),
        this.props.vertical === 'top' ? upArrow() : downArrow()
      );
    }
  }, {
    key: 'renderLanguages',
    value: function renderLanguages() {
      var _this3 = this;

      return languages.map(function (language) {
        return _react2.default.createElement(
          _VstDropdown2.default.Item,
          {
            key: 'locales-' + language.short,
            className: 'vst-language ' + _this3.props.className,
            selected: _this3.state.selected === language.short,
            onClick: function onClick() {
              return _this3.onClick(language.short);
            },
            style: {
              backgroundImage: 'url(\'' + path + '/' + language.img + '\')',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '10px',
              paddingLeft: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }
          },
          language.long,
          _this3.state.selected === language.short && checkmark()
        );
      });
    }
  }]);

  return VstLocales;
}(_react2.default.Component);

exports.default = VstLocales;


VstLocales.propTypes = {
  selected: _propTypes2.default.string,
  className: _propTypes2.default.string,
  label: _propTypes2.default.string,
  menuName: _propTypes2.default.string,
  headerTitle: _propTypes2.default.string,
  customX: _propTypes2.default.number,
  customY: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  horizontal: _propTypes2.default.oneOf(['left', 'right']),
  vertical: _propTypes2.default.oneOf(['bottom', 'top']),
  height: _propTypes2.default.string,
  headerBackButton: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  customText: _propTypes2.default.string,
  showBackBtn: false,
  showApplyBtn: false
};

VstLocales.defaultProps = {
  selected: 'en',
  className: '',
  label: '',
  menuName: '',
  headerTitle: 'Language',
  customX: 0,
  customY: 0,
  vertical: 'top',
  horizontal: 'left',
  height: '400px',
  isMobile: false,
  showBackBtn: true,
  customText: '',
  showApplyBtn: true,
  headerBackButton: 'Language'
};


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstLocales.js
 **/